/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translations base file
 *
 * @file index.js
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.0
 */

import arJson from './ar.json';
import deJson from './de.json';
import enJson from './en.json';
import esJson from './es.json';
import frCaJson from './fr-ca.json';
import itJson from './it.json';
import trJson from './tr.json';

 
const messages = {
  'ar': arJson,
  'de': deJson,
  'de-de': deJson,
  'en': enJson,
  'en-us': enJson,
  'es': esJson,
  'es-es': esJson,
  'es-la': esJson,
  'fr-ca': frCaJson,
  'it': itJson,
  'it-it': itJson,
  'tr': trJson,
  'tr-tr': trJson
};

export default messages;
